import type { SettingsColumnHead } from '@/modules/settings';

/** The column titles, rendered in the page's sticky header. */
export const RULES_ACTIVITY_COLUMNS: SettingsColumnHead[] = [
	{ id: 'at', header: 'Time', className: 'w-[150px]' },
	{ id: 'ticket', header: 'Ticket', className: 'w-[130px]' },
	{ id: 'where', header: 'Helpdesk · channel', className: 'w-[170px]' },
	{ id: 'rule', header: 'Decided by' },
	{ id: 'outcome', header: 'What happened', className: 'w-[200px]' },
	{ id: 'reply', header: 'Reply sent', className: 'w-[100px]' },
	{ id: 'ms', header: 'Time taken', className: 'w-[100px] justify-end' }
];
